<script>
import {CorporateDashboard} from "../controllers/dashboard";

export default {
    name: "CorporateDashboard",
    mixins: [CorporateDashboard],
    props: ['permissions'],
}
</script>

<template>
    <!-- Middle Panel ============================================= -->
    <div class="col-lg-9">
        <div class="bg-white shadow-sm rounded p-4 mb-4">
            <h3 class="text-5 fw-400 d-flex align-items-center mb-4">Welcome to Magetsi Business</h3>
            <p class="mb-0">Choose your action</p>
            <hr class="mb-4 mx-n4">
            <div class="row gy-4 profile-completeness">
                <div class="col-12 col-sm-12 col-lg-4 mb-2">
                    <router-link
                        :to="`/business/transact`"
                    >
                        <div class="hover-border hover-section shadow-sm rounded text-center px-3 py-4">
                        <span class="d-block text-10 text-light mt-2 mb-3">
                            <i class="fas fa-money-bill-wave service-icon"></i>
                        </span>
                            <p class="mb-0 text-3 service-text"><b>Pay Bills</b></p>
                            <small class="service-text-small">Bulk payments for your business</small>
                        </div>
                    </router-link>
                </div>
                <div class="col-12  col-sm-12 col-lg-4 mb-2">
                    <router-link
                        :to="`/business/payments`"
                    >
                        <div class="hover-border hover-section shadow-sm rounded text-center px-3 py-4">
                        <span class="d-block text-10 text-light mt-2 mb-3">
                            <i class="fas fa-hand-holding-usd service-icon"></i>
                        </span>
                            <p class="mb-0 text-3 service-text"><b>Receive Payments</b></p>
                            <small class="service-text-small">Receive payments as a biller on Magetsi</small>
                        </div>
                    </router-link>
                </div>
                <div class="col-12  col-sm-12 col-lg-4 mb-2">
                    <router-link
                        :to="`/business/events`"
                    >
                        <div class="hover-border  hover-section shadow-sm rounded text-center px-3 py-4">
                        <span class="d-block text-10 text-light mt-2 mb-3">
                            <i class="fas fa-ticket-alt service-icon"></i>
                        </span>
                            <p class="mb-0 text-3 service-text"><b>Sell Event Tickets</b></p>
                            <small class="service-text-small">Sell e-tickets for event on Magetsi</small>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <template v-if="wallets && wallets.length">
            <!-- Profile Wallets =============================== -->
            <div class="bg-light shadow-sm rounded p-4 mb-4">

                <div class="d-flex align-items-center mb-4 justify-content-between">
                    <h3 class="text-5 font-weight-400 d-flex align-items-center mb-0">
                        Business Wallets
                        <span class="bg-light-4 text-success rounded px-2 py-1 font-weight-400 text-2 ml-2">
                            {{ wallets.length }}
                        </span>
                    </h3>
                    <router-link
                        to="/business/wallets/deposit"
                        class="btn btn-outline-primary btn-sm px-3 shadow-none"
                        v-if="hasPermission(permissions, 'input-transactions')"
                    >
                        <i class="fas fa-arrow-down"></i>
                        Fund Wallets
                    </router-link>
                </div>
                <div class="row">
                    <div class="wallets-container">
                        <div class="d-flex flex-nowrap">
                            <div
                                v-for="(wallet, index) in wallets"
                                :key="index"
                                class="wallet-item col-10 col-sm-6 col-lg-4 mb-4"
                            >
                                <router-link
                                    :to="`/business/wallet/${wallet.id}/view`"
                                    :class="wallet.type === 'Corporate' ? 'account-card-primary' : ''"
                                    class="d-block account-card text-white rounded p-3 mb-4 mb-lg-0"
                                >
                                    <small class="text-uppercase font-weight-700">{{ wallet.type }}</small>
                                    <p class="text-4 text-uppercase mt-n2 mb-1">
                                        {{ wallet.currency }} Wallet
                                    </p>
                                    <p class="d-flex align-items-center mb-1">
                                        <span class="account-card-expire border-left text-uppercase d-inline-block opacity-6 mr-2">
                                            Active<br />Since<br />
                                        </span>
                                        <span class="text-1 opacity-9">
                                        {{ new Date(wallet.created_at).toLocaleDateString() }}
                                        </span>
                                        <span
                                            class="bg-light text-0 text-body font-weight-500 rounded-pill d-inline-block px-2 line-height-4 opacity-8 ml-auto"
                                        >
                                            {{ wallet.status }}
                                        </span>
                                    </p>
                                    <p class="d-flex align-items-center m-0">
                                    <span class="text-uppercase text-4 font-weight-500">
                                        {{ wallet.currency }} {{ money(wallet.balance) }}
                                    </span>
                                        <i class="fas fa-wallet ml-auto"></i>
                                    </p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Profile Completeness End -->
        </template>

        <!-- Recent Activity =============================== -->
        <div class="bg-light shadow-sm rounded py-4 mb-4">
            <h3 class="text-5 font-weight-400 d-flex align-items-center px-4 mb-3">Recent Activity</h3>

            <!-- Title =============================== -->
            <div class="transaction-title py-2 px-4">
                <div class="row">
                    <div class="col-2 col-sm-1 text-center"><span class="">Date</span></div>
                    <div class="col col-sm-7">Description</div>
                    <div class="col-auto col-sm-2 d-none d-sm-block text-center">Status</div>
                    <div class="col-3 col-sm-2 text-right">Amount</div>
                </div>
            </div>
            <!-- Title End -->

            <!-- Transaction List =============================== -->
            <div class="transaction-list">
                <div v-if="!data.content.data.length" class="text-center p-4">
                    No transactions at the moment. Check again in a while
                </div>
                <router-link v-for="row in data.content.data"
                             :key="row.id"
                             :to="`/business/view?ref=${row.ref}`"
                             class="transaction-item d-block px-4 py-3">
                    <div class="row align-items-center flex-row">
                        <div class="col-2 col-sm-1 text-center">
                            <span class="d-block text-4 font-weight-300">{{ row.day }}</span>
                            <span class="d-block text-1 font-weight-300 text-uppercase">{{ row.month }}</span>
                        </div>
                        <div class="col col-sm-7">
                            <span class="d-block text-4">Transaction #{{ row.code }}</span>
                            <span class="text-muted">{{ row.state }}</span>
                        </div>
                        <div class="col-auto col-sm-2 d-none d-sm-block text-center text-2" :title="row.state">
                            <span v-if="row.state.includes('AUTHORISATION-REQUIRED')" class="text-warning">
                                <i class="fas fa-exclamation-triangle"></i>
                            </span>
                            <span v-if="row.state.includes('COMPLETED')" class="text-success">
                                <i class="fas fa-check-circle"></i>
                            </span>
                        </div>
                        <div class="col-3 col-sm-2 text-right text-2">
                            <span class="text-nowrap">${{ money(row.meta.total) }} ({{ row.currency }})</span>
                        </div>
                    </div>
                </router-link>
            </div>
            <!-- Transaction List End -->

            <div class="text-center mt-4">
                <router-link to="/business/batches" class="btn-link text-2">
                    View all<i class="fas fa-chevron-right text-2 ml-2"></i>
                </router-link>
            </div>
        </div>
        <!-- Recent Activity End -->
    </div>
    <!-- Middle Panel End -->
</template>
<style scoped>
.wallets-container {
    overflow-x: auto;
    white-space: nowrap;
}

.wallets-container .d-flex {
    display: inline-flex;
}

.wallet-item {
    flex: 0 0 auto;
    width: 900px;
    margin-right: -20px;
}
.hover-border {
    border: 1px solid #ddd;
    transition: border-color 0.3s ease;
}
.hover-border:hover {
    border-color: #28a745;
}
.service-text{
    color: #212529
}
.service-text-small{
    color: #4c4d4d
}
.service-icon {
    color: #dee3e4;
    transition: color 0.3s ease;
}
.hover-section:hover .service-icon {
    color: #28a745;
}
</style>
